<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card class="px-0">
      <div>
        <v-card-title class="headline pl-4 py-2 pr-2">
          Zmiana hasła
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>

        </v-card-title>
        <v-divider></v-divider>
        <div
          ref="scrollContainer"
          class="scrollable-height">
          <v-alert
            v-model="error"
            class="ma-0"
            dismissible
            type="error"
          >
            {{errorMsg}}
          </v-alert>
          <div class="py-2">
            <div class="px-4">
              <v-text-field
                v-model.trim="formData.current_password"
                label="Stare hasło"
                :type="'password'"
                :error-messages="errors.collect('current_password')"
                v-validate="'required|min:6|max:20'"
                data-vv-name="current_password"
                data-vv-as="stare hasło"
                required
              ></v-text-field>
            </div>
            <div class="px-4">
              <v-text-field
                ref="password"
                v-model.trim="formData.password"
                label="Nowe hasło"
                :type="'password'"
                data-vv-delay="1000"
                :error-messages="errors.collect('password')"
                v-validate="'required|min:6|max:20'"
                data-vv-name="password"
                data-vv-as="nowe hasło"
                hint="Hasło musi mieć od 6 do 20 znaków, musi zawierać co najmniej:
              jedną małą literę, jedną wielką literę, jedną liczbę oraz jeden znak specjalny"
              ></v-text-field>
            </div>
            <div class="px-4 pb-2">
              <v-text-field
                v-model.trim="formData.password_confirmation"
                label="Powtórz nowe hasło"
                :type="'password'"
                data-vv-delay="1000"
                :error-messages="errors.collect('repeat_password')"
                v-validate="'confirmed:password'"
                data-vv-name="repeat_password"
                data-vv-as="powtórz nowe hasło"
              ></v-text-field>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <ServerErrors :errorsItems="serverErrors" />

          <v-spacer></v-spacer>

          <v-btn
            color="primary lighten-2"
            flat="flat"
            @click="setVisbility"
          >
            Anuluj
          </v-btn>

          <v-btn
            color="primary"
            :loading="busy"
            :disabled="busy"
            @click="storePassword"
          >
            Zapisz
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { setPassword } from '../../../repository/auth';
import { getError } from '../../../helpers/helpers';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'users-access-dialog',
  components: {
    ServerErrors,
  },
  data: () => ({
    errorMsg: null,
    error: false,
    serverErrors: [],
    formData: {
      current_password: null,
      password: null,
      password_confirmation: null,
    },
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    userId() {
      return this.dialogVisibility.userId;
    },
    visibility: {
      get() {
        return this.dialogVisibility.type === 'change-password';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      this.$refs.scrollContainer.scrollTo(0, 0);
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.formData = {
        current_password: null,
        password: null,
        password_confirmation: null,
      };
    },
    storePassword() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.setNewPassword();
        }
      });
    },
    async setNewPassword() {
      this.busy = true;
      try {
        await setPassword(this.formData);
        this.setDialogVisbility(false);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
